import { OpenedContactShort, ProgAIProfile } from 'shared/generated-models';

export const getProfileInitials = ({ last_name, first_name, github_handle }: ProgAIProfile | OpenedContactShort) => {
	if (last_name && first_name) return `${first_name[0]}${last_name[0]}`.toUpperCase();
	if (github_handle) return `${github_handle[0]}`.toUpperCase();
	return '';
};
